<template>
<div class="chapter">
<div class="inner_page">
<p class="t1">
<b class="calibre6">LITTLE MISS MOUSE</b><br class="calibre5"/>
</p>
<p class="calibre3"><br class="calibre4"/>
</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section00_0003_split_000.vue?556ab454